import { motion } from "framer-motion";

const STATS = [
  { id: "ages", big: "18–45", label: "Ages", sub: "Curated for young adult adventurers" },
  { id: "size", big: "12", label: "Travelers max", sub: "Intimate groups, real connections" },
  { id: "style", big: "Small", label: "Group adventures", sub: "Hand-picked itineraries, hosted crews" },
];

export const StatsStrip = () => (
  <section className="bg-ink text-cream noise-bg border-y border-white/10" data-testid="stats-strip">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
      {STATS.map((s, i) => (
        <motion.div
          key={s.id}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.7, delay: i * 0.1, ease: [0.215, 0.61, 0.355, 1] }}
          className="text-center md:text-left md:border-l md:border-flame md:pl-6"
          data-testid={`stats-strip-${s.id}`}
        >
          <p className="font-display text-6xl sm:text-7xl leading-none uppercase">
            {s.big}<span className="text-flame">.</span>
          </p>
          <p className="mt-3 text-xs font-bold uppercase tracking-[0.25em] text-cream">{s.label}</p>
          <p className="mt-1 text-sm text-cream/60">{s.sub}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
